import React from 'react';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import { Tabs, Tab, Alert } from 'react-bootstrap';
import Form from '../form/Form';
import FieldGroup from '../field_group/FieldGroup';
import { listACBrand } from '../../redux/references/ac_actions';
import { requiredValidator } from '../field_group/validators';
import { fromCoolingCap, getErrorValue, stringifyErrorMessage } from '../../utils/utility';
import PackagedSubDataTable from './PackagedSubDataTable';

export class ACPackagedUnitDetail extends React.Component {
  constructor(props) {
    super(props);
    this.formRef = undefined;

    this.state = {
      tabActiveKey: 1,
    };
  }

  renderOption(item, prefix) {
    return (
      <option key={prefix ? `${prefix}${item.id}` : item.id} value={item.id}>
        {item.name}
      </option>
    );
  }

  getACData() {
    return this.formRef.getFormData(['cooling_capacity']);
  }

  componentDidMount() {
    this.props.listBrand();
  }

  renderBasicInfo() {
    const {
      name,
      brand_id,
      type,
      SEER,
      cooling_capacity,
      unit,
      power_required,
      description,
      image,
    } = this.props.ac;

    const { t, ref, disabled, fieldErrors, errorMessage, ...otherAttr } = this.props;
    const customAttr = { disabled };

    return (
      <Form image={image} {...otherAttr} ref={ref => (this.formRef = ref)}>
        <FieldGroup
          id="air-conditioning-package-unit-name"
          field="name"
          type="text"
          label={t('name')}
          placeholder="Name"
          value={name}
          validators={[requiredValidator]}
          errorMessage={getErrorValue(fieldErrors, 'name')}
          {...customAttr}
        />
        <FieldGroup
          id="air-conditioning-package-unit-type"
          field="type"
          componentClass="select"
          label={t('type')}
          placeholder={t('type')}
          value={type}
          defaultDirty={true}
          {...customAttr}
        >
          {this.props.types.map(type => this.renderOption(type, 'act'))}
        </FieldGroup>
        <FieldGroup
          id="air-conditioning-package-unit-brand"
          field="brand_id"
          componentClass="select"
          label={t('brand')}
          placeholder={t('brand')}
          value={brand_id}
          defaultDirty={true}
          {...customAttr}
        >
          {this.props.brands.map(brand => this.renderOption(brand, 'acb'))}
        </FieldGroup>
        <FieldGroup
          id="air-conditioning-package-unit-cooling-capacity"
          field="cooling_capacity"
          type="number"
          label={t('cooling capacity')}
          placeholder="100"
          value={fromCoolingCap(cooling_capacity, unit)}
          validators={[requiredValidator]}
          errorMessage={getErrorValue(fieldErrors, 'cooling_capacity')}
          {...customAttr}
        />
        <FieldGroup
          id="air-conditioning-package-unit-unit"
          field="unit"
          componentClass="select"
          label={t('unit')}
          value={unit}
          defaultDirty={true}
          {...customAttr}
        >
          {this.props.units.map(unit => this.renderOption(unit, 'acu'))}
        </FieldGroup>
        <FieldGroup
          id="air-conditioning-package-unit-power-required"
          field="power_required"
          type="number"
          label={t('power (kW)')}
          placeholder="12"
          value={power_required}
          validators={[requiredValidator]}
          errorMessage={getErrorValue(fieldErrors, 'power_required')}
          {...customAttr}
        />
        <FieldGroup
          id="air-conditioning-package-unit-description"
          field="description"
          componentClass="textarea"
          label={t('description')}
          value={description}
          {...customAttr}
        />
      </Form>
    );
  }

  renderPackagedSub() {
    const {
      t,
      ac: { id: acPackagedId, packaged_sub_list },
    } = this.props;

    return (
      <Tab eventKey={2} title={t('ac packaged sub')}>
        <PackagedSubDataTable
          acPackagedId={acPackagedId}
          packagedSubs={packaged_sub_list}
          onEditItem={item => this.setState({ selectedItem: item })}
        />
      </Tab>
    );
  }

  renderErrorMessage(errorMessage) {
    if (!errorMessage) return null;
    return (
      <Alert
        bsStyle="danger"
        style={{ 'white-space': 'pre' }}
      >
        {errorMessage}
      </Alert>
    );
  }

  render() {
    const { t, ac, errorMessage } = this.props;
    const { tabActiveKey } = this.state;
    const detailError = stringifyErrorMessage(errorMessage);
    return (
      <React.Fragment>
        {detailError ? this.renderErrorMessage(detailError) : null}
        <Tabs
          id="air-conditioning-package-unit-packaged-tabs"
          activeKey={tabActiveKey}
          onSelect={ key => this.setState({ tabActiveKey: key}) }
        >
          <Tab
            eventKey={1}
            title={t('basic info')}
          >
            {this.renderBasicInfo()}
          </Tab>
          {ac.id ? this.renderPackagedSub() : null}
        </Tabs>
      </React.Fragment>
    );
  }
}

ACPackagedUnitDetail.defaultProps = {
  ac: {},
};

const mapStateToProps = state => ({
  brands: state.reference.ac.brandList,
  types: state.reference.ac.puTypes,
  units: state.reference.ac.coolingCapacityUnit,
  errorMessage: state.ac.packagedUnit.errorMessage,
});

const mapDispatchToProps = dispatch => ({
  listBrand: () => dispatch(listACBrand()),
});

export default translate('translations', { withRef: true })(
  connect(
    mapStateToProps,
    mapDispatchToProps,
    null,
    { withRef: true },
  )(ACPackagedUnitDetail),
);



// WEBPACK FOOTER //
// ./src/components/ac_packaged_unit/ACPackagedUnitDetail.js